import React, { useEffect, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import correct from '../../../assets/icons/e-learning/user/correct.svg'
import styles from '../elearning.module.css'
import * as api from '../../services/api'
import Loader from 'components/Loader';

function TestBeforeClass() {
    const navigate = useNavigate()
    const location = useLocation()
    const [loading, setLoading] = useState(false)

    const [detail, setDetail] = useState([])
    const [question, setQuestion] = useState([])
    const [option, setOption] = useState([])
    const [option1, setOption1] = useState([])
    const [optionAnswer, setOptionAnswer] = useState([])

    const [registerNumber, setRegisterNumber] = useState(null)

    if (!location.state) {
        location.state = { button: "1" };
    }

    useEffect(() => {
        let data = location.state.item
        // console.log(data)
        setRegisterNumber(location.state.register_number)
        setDetail(data)
        if (data['pre_test_form'] === null) {
            setQuestion([])
        } else {
            setQuestion(data['pre_test_form'])
        }
    }, [])

    const handleButton = (number) => {
        navigate('/testBeforeClass', { state: { button: number } });
    };

    const handleChooseChoice = (event, index, item) => {
        const { value } = event.target
        const filteredItems = item['question_answer'].filter((item) =>
            item.name === value
        )
        option1[index] = filteredItems[0]['value']
        setOption1([...option1])

        optionAnswer[index] = filteredItems[0]
        setOptionAnswer([...optionAnswer])

        option[index] = value
        setOption([...option])
    }

    const handleClickSaveTest = () => {
        // console.log(option1, question)
        // console.log(optionAnswer)
        
        if (question.length > 0) {
            if (option1.length === question.length) {
                let inform = {
                    "e_learning_code": detail['e_learning_code'],
                    "e_learning_group_code": detail['e_learning_group_code'],
                    "test_type": "pre_test",
                    "question": question,
                    // "answer": option1,
                    "answer": optionAnswer,
                    "score": option1.reduce((accumulator, currentValue) => parseInt(accumulator) + parseInt(currentValue), 0)
                }
                console.log(inform)
                newTestRecord(inform)
            } else {
                alert('กรุณาทำแบบทดสอบให้ครบทุกข้อ')
            }
        } else {
            startCourse()
        }
    }

    const newTestRecord = async (data) => {
        setLoading(true)
        let res = await api.newTestRecord(data)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                handleButton("2")
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const startCourse = async () => {
        setLoading(true)
        let res = await api.startCourse(detail['e_learning_group_code'], detail['e_learning_code'], registerNumber)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // console.log(res['data'])
                console.log(res['data']['message'])
                navigate('/classroom', { state: { item: detail, register_number: registerNumber } })
            } else {
                // //alert(res['data']['message'])
                console.log(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/manageUserELearning') }}
                    >กลับไป ห้องเรียนออนไลน์</Box>
                </Box>

                <Box>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: '20px'
                    }}>{detail['e_learning_name']}</Typography>
                </Box>

                <Box>
                    <Typography>แบบทดสอบก่อนเรียน</Typography>
                </Box>

                {location.state.button === "1" ? (
                    <>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            padding: '20px',
                            display: 'grid',
                            gridGap: '10px'
                        }}>
                            {question.length > 0 ?
                                <>
                                    {question.map((item, index) => (
                                        <Box key={index}>
                                            <Typography sx={{ fontWeight: 500 }}>ข้อที่{index + 1}. {item?.['question_name']}</Typography>
                                            <Box sx={{ marginLeft: '5%' }}>
                                                <FormControl>
                                                    <RadioGroup
                                                        value={option[index] ? option[index] : ''}
                                                        onChange={(e) => { handleChooseChoice(e, index, item) }}
                                                    >
                                                        {item['question_answer'].map((i, idx) => (
                                                            <FormControlLabel key={idx} value={i['name']} control={<Radio />} label={i['name']} />
                                                        ))}
                                                    </RadioGroup>
                                                </FormControl>
                                            </Box>

                                            <Box sx={{ borderTop: '1px solid #D9D9D9' }}></Box>
                                        </Box>
                                    ))}
                                </>
                                :
                                <Typography sx={{ fontWeight: 600, textAlign: 'center' }}>ไม่มีแบบทดสอบก่อนเรียน</Typography>
                            }
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Button variant='contained' onClick={() => { handleClickSaveTest() }}>
                                {question.length > 0 ? 'บันทึก' : 'เริ่มเข้าห้องเรียน'}
                            </Button>
                        </Box>
                    </>
                ) : null}

                {location.state.button === "2" ? (
                    <>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            padding: '20px'
                        }}>
                            <Box sx={{
                                display: 'grid',
                                gridGap: '10px',
                                justifyItems: 'center',
                                margin: '40px 0'
                            }}>
                                <img src={correct} className={styles.correct} />
                                <Typography sx={{ fontWeight: 600 }}>บันทึกแบบทดสอบก่อนเรียนแล้ว</Typography>
                                <Typography>กด “เริ่มเข้าห้องเรียน” เพื่อเริ่มบทเรียนแรกได้เลย</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant='contained' onClick={() => { startCourse() }}>เริ่มเข้าห้องเรียน</Button>
                        </Box>
                    </>
                ) : null}



            </Box>
        </>
    )
}

export default TestBeforeClass
